export default function getPercentileLabel(percentage: number) {
  const suffixes = ['th', 'st', 'nd', 'rd']
  const lastDigit = percentage % 10
  let suffixIndex = 0
  if (percentage > 10 && percentage < 20) {
    suffixIndex = 0
  } else {
    suffixIndex = lastDigit >= 4 ? 0 : lastDigit
  }
  return `${percentage}${suffixes[suffixIndex]}`
}
